module.exports = __webpack_public_path__ + "img/master-sm.6b35e827.svg";